import { environment } from 'src/environments/environment.prod'

export const S3_OPERATIONS_SERVICE_ROUTE = `${environment.operationsApi}/api/v1`
